import React, { Component, useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import axios from 'axios';
//import logo from './logo.svg';
//import logo from './images/DashboardIcon/Icon/gazelle.jpg';
import './App.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from 'react-hot-toast';
// import { BrowserRouter } from 'react-router-dom'

import { Auth } from './components/Auth/Auth'
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import {loadProperties, getPlatformProperty} from "./config/ConfigHelper";
import { SessionContext } from './session/SessionProvider'
// import { Auth0Provider } from '@auth0/auth0-react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//barricade
// import BarricadeDashboard from './components/barricade/Dashboard';
// import WeeklyNewsletter from './components/barricade/WeeklyNewsletter';
// import WeeklyIdentityReport from './components/barricade/WeeklyIdentityReport';
// import WeeklySocialProfileReport from './components/barricade/WeeklySocialProfileReport';
// import InstantBreachAlerts from './components/barricade/InstantBreachAlerts';
//import BillingNotifications from './components/barricade/BillingNotifications';
//core
import Header from './components/navigation/Header';
import LeftNav from './components/navigation/LeftNav';
import Content from './components/Content';
import Desktops from './components/vlm/Desktops';
import DesktopEdit from './components/DesktopEdit';
import DesktopCreate from './components/DesktopCreate';
import DesktopViewer from './components/DesktopViewer';
// 
import HomepageNeo from './components/navigation/HomepageNeo';
import HomepageDynamo from './components/navigation/HomepageDynamo';
import HomepageBreeze from './components/navigation/HomepageBreeze';
import HomepageTelony from './components/navigation/HomepageTelony';
import HomepageEqius from './components/navigation/HomepageEqius';
// 
import HomepageWaves from './components/navigation/HomepageWaves';
import HomepageDTS from './components/navigation/HomepageDTS';
import HomepageDTS2 from './components/navigation/HomepageDTS2';
import HomepageAbacus from './components/navigation/HomepageAbacus';
import HomepageVLM from './components/navigation/HomepageVLM';
//import HomepageBarricade from './components/HomepageBarricade';
import HomepageMCT from './components/navigation/HomepageMCT';
import Dashboard from './components/navigation/Dashboard';
import DashboardMCT from './components/navigation/DashboardMCT';
import Projects from './components/core/Projects';
import ProjectViewer from './components/core/ProjectViewer';
import ProjectCreate from './components/core/ProjectCreate';
import ProjectManage from './components/core/ProjectManage';
import ContentViewer from './components/ContentViewer';
import ContentEditor from './components/ContentEditor';
import MyDocuments from './components/core/MyDocuments';
import MyMusic from './components/core/MyMusic';
import MyPhotos from './components/core/MyPhotos';
import MyVideos from './components/core/MyVideos';
import MyLinks from './components/core/MyLinks';

import Calendar from './components/vlm/Calendar';
import Articles from './components/vlm/Articles';
import KnowledgeBase from './components/KnowledgeBase';
import UserProfile from './components/core/UserProfile';
//neo 
import NeoHomePage from "./components/neo/HomePage";
import CreateConnector from "./components/neo/CreateConnector";
import CreateService from "./components/neo/CreateService";
import CreateNeoTransformer from "./components/neo/CreateTransformer";
import ManageNeoTransformer from "./components/neo/ManageTransformer";
import ManageConnector from "./components/neo/ManageConnector";
import ManageService from "./components/neo/ManageService";
import ServiceScheduler from "./components/neo/ServiceScheduler";
import Connectors from "./components/neo/Connectors";
import Services from "./components/neo/Services";
import NeoTransformers from "./components/neo/Transformers";
import FindConnectors from "./components/neo/FindConnectors";
import FindServices from "./components/neo/FindServices";
import FindNeoTransformers from "./components/neo/FindTransformers";


//dynamo
import DynamoHomePage from "./components/dynamo/HomePage";
import ManageProject from "./components/dynamo/ManageProject";
import ManageRecipes from "./components/dynamo/ManageRecipes";
import CreateRecipe from "./components/dynamo/CreateRecipe";
import RecipeDetail from "./components/dynamo/RecipeDetail";
import RecipeSearch from "./components/dynamo/RecipeSearch";
import RecipeStepSearch from "./components/dynamo/RecipeStepSearch";
import RecipeStepDetail from "./components/dynamo/RecipeStepDetail";
import RecipeStepCreate from "./components/dynamo/RecipeStepCreate";
import Triggers from "./components/dynamo/Triggers";
import TriggerDetail from "./components/dynamo/TriggerDetail"
import TriggerCreate from"./components/dynamo/TriggerCreate";
import LayoutDetails from "./components/dynamo/LayoutDetails";
import BuildDetails from "./components/dynamo/BuildDetails";
import DeployDetails from "./components/dynamo/DeployDetails";
import ProjectRecipes from "./components/dynamo/ProjectRecipes";
import DynamoTransformers from "./components/dynamo/Transformers";
import ManageDynamoTransformer from "./components/dynamo/ManageTransformer"
import CreateDynamoTransformer from "./components/dynamo/CreateTransformer";
import FindDynamoTransformers from "./components/dynamo/FindTransformers";
//waves
import WavesHomePage from "./components/waves/HomePage";
import ViewVCSObjects from "./components/waves/ViewVCSObjects";
import ViewVCSCheckedoutObjects from "./components/waves/ViewVCSCheckedoutObjects";
import ViewVCSLabels from "./components/waves/ViewVCSLabels";
import CreateVCSObject from "./components/waves/CreateVCSObject";
import CreateVCSVersion from "./components/waves/CreateVCSVersion";
import CreateVCSLabel from "./components/waves/CreateVCSLabel";
import CreateVCSCheckoutObject from "./components/waves/CreateVCSCheckoutObject";

//breeze 
import BreezeHomePage from "./components/breeze/HomePage";
import ContentSearch from "./components/breeze/ContentSearch";
import BreezeContentViewer from "./components/breeze/ContentViewer";
// import ContentEditor from "./components/breeze/manage/ContentEditor";
import CreateContent from "./components/breeze/create/CreateContent";
import CreateContentType from "./components/breeze/create/CreateContentType";
import CreateContentApplication from"./components/breeze/create/CreateContentApplication";
//import { importNamespaceSpecifier } from '@babel/types';
import CreateContentAnnotation from "./components/breeze/create/CreateContentAnnotation";
import CreateContentAssociations from "./components/breeze/create/CreateContentAssociations";
import CreateContentAssociationType from "./components/breeze/create/CreateContentAssociationType";
import CreateContentCategories from "./components/breeze/create/CreateContentCategories";
import CreateContentCategoryType from "./components/breeze/create/CreateContentCategoryType";
import CreateContentDescriptor from "./components/breeze/create/CreateContentDescriptors";
import CreateContentDescriptorType from "./components/breeze/create/CreateContentDescriptorType";
import CreateContentFacades from "./components/breeze/create/CreateContentFacades";
import CreateContentFacadesType from "./components/breeze/create/CreateContentFacadeType";
import CreateContentIndexType from "./components/breeze/create/CreateContentIndexType";
import CreateContentIndex from "./components/breeze/create/CreateContentIndices";
import CreateContentTemplate from "./components/breeze/create/CreateContentTemplates";
import CreateContentTemplateType from "./components/breeze/create/CreateContentTemplateType";
import ManageContent from "./components/breeze/manage/ManageContent";
import ManageContentAssociations from "./components/breeze/manage/ManageContentAssociations";
import ManageContentAssociationsTypes from "./components/breeze/manage/ManageContentAssociationTypes";
import ManageContentCategories from "./components/breeze/manage/ManageContentCategories";
import ManageContentCategoryTypes from "./components/breeze/manage/ManageContentCategoryTypes";
import ManageContentDescriptors from "./components/breeze/manage/ManageContentDescriptors";
import ManageContentDescriptorTypes from "./components/breeze/manage/ManageContentDescriptorTypes";
import ManagecContentFacades from "./components/breeze/manage/ManageContentFacades";
import ManagecContentFacadeTypes from "./components/breeze/manage/ManageContentFacadeTypes";
import ManageContentTypes from "./components/breeze/manage/ManageContentTypes";
import ManageContentIndices from "./components/breeze/manage/ManageContentIndices";
import ManageContentIndexTypes from "./components/breeze/manage/ManageContentIndexTypes";
import ManageContentTemplates from "./components/breeze/manage/ManageContentTemplates";
import ManageContentTemplateTypes from "./components/breeze/manage/ManageContentTemplateTypes";
import ManageContentTransformations from "./components/breeze/manage/ManageContentTransformations";


import ListContent from "./components/breeze/search/ListContent";
import ListImageCatalog from "./components/breeze/search/ListImageCatalog";
import ListContentAssociationTypes from "./components/breeze/search/ListContentAssociationTypes";
import ListContentAssociations from "./components/breeze/search/ListContentAssociations";
import ListContentCategories from "./components/breeze/search/ListContentCategories";
import ListContentCategoryTypes from "./components/breeze/search/ListContentCategoryTypes";
import ListContentDescriptorTypes from "./components/breeze/search/ListContentDescriptorTypes";
import ListContentDescriptors from "./components/breeze/search/ListContentDescriptors";
import ListContentFacadeTypes from "./components/breeze/search/ListContentFacadeTypes";
import ListContentFacades from "./components/breeze/search/ListContentFacades";
import ListContentIndexTypes from "./components/breeze/search/ListContentIndexTypes";
import ListContentIndices from "./components/breeze/search/ListContentIndices";
import ListContentTemplateTypes from "./components/breeze/search/ListContentTemplateTypes";
import ListContentTemplates from "./components/breeze/search/ListContentTemplates";
import ListContentTypes from "./components/breeze/search/ListContentTypes";
// 
// import HomePage2 from"./components/breeze/gazelle-edx/HomePage2";
// import CreateActivityCharge from"./components/breeze/gazelle-edx/CreateActivityCharge";
// import CreateContainer from"./components/breeze/gazelle-edx/CreateContainer";
// import CreateDocumentDelivery from"./components/breeze/gazelle-edx/CreateDocumentDelivery";
// import CreateWorkOrder from"./components/breeze/gazelle-edx/CreateWorkOrder";
// import CreateWorkOrderMaterial from"./components/breeze/gazelle-edx/CreateWorkOrderMaterial";
// import ManageActivityCharges from"./components/breeze/gazelle-edx/ManageActivityCharges";
// import ManageContainer from"./components/breeze/gazelle-edx/ManageContainer";
// import ManageDocumentDelivery from"./components/breeze/gazelle-edx/ManageDocumentDelivery";
// import ManageWorkOrder from"./components/breeze/gazelle-edx/ManageWorkOrder";
// import ManageWorkOrderMaterials from"./components/breeze/gazelle-edx/ManageWorkOrderMaterials";
// import ListActivityCharges from "./components/breeze/gazelle-edx/ListActivityCharges";
// import ListDocumentDeliveries from"./components/breeze/gazelle-edx/ListDocumentDeliveries";
// import ListWorkOrderMaterials from"./components/breeze/gazelle-edx/ListWorkOrderMaterials";
// import listWorkOrder from"./components/breeze/gazelle-edx/ListWorkOrders";
// import listContainers from"./components/breeze/gazelle-edx/ListContainers";
// import SelectListComponents from"./components/breeze/SelectListComponent";
// //eqius
// import EqiusHomePage from './components/eqius/HomePage';
// import WorkflowCaseSearchResults from './components/eqius/workflow/WorkflowCaseSearchResults';
// import WorkflowCaseCreate from './components/eqius/workflow/WorkflowCaseCreate';
// import WorkflowCaseDetails from './components/eqius/workflow/WorkflowCaseDetails';
// import WorkflowSearchResults from './components/eqius/workflow/WorkflowSearchResults';
// import WorkflowCreate from './components/eqius/workflow/WorkflowCreate';
// import WorkflowDetails from './components/eqius/workflow/WorkflowDetails';
// import WorkflowMultiQueueForm from './components/eqius/workflow/WorkflowMultiQueueForm';
// 
// import CustomersSearch from './components/eqius/crm/CustomersSearch';
// import DonorsSearch from './components/eqius/crm/DonorsSearch';
// import MembersSearch from './components/eqius/crm/MembersSearch';
// import ProspectsSearch from './components/eqius/crm/ProspectsSearch';
// import ClientsSearch from './components/eqius/crm/ClientsSearch';
// 
// import CustomerCreate from './components/eqius/crm/CustomerCreate';
// import DonorCreate from './components/eqius/crm/DonorsCreate';
// import MemberCreate from './components/eqius/crm/MembersCreate';
// import ProspectCreate from './components/eqius/crm/ProspectsCreate';
// import ClientCreate from './components/eqius/crm/ClientsCreate';
// 
// import CustomerDetails from './components/eqius/crm/CustomerDetails';
// import DonorDetails from './components/eqius/crm/DonorsDetails';
// import MemberDetails from './components/eqius/crm/MembersDetails';
// import ProspectDetails from './components/eqius/crm/ProspectsDetails';
// import ClientDetails from './components/eqius/crm/ClientsDetails';
// 
// import AuthorsSearch from './components/eqius/crm/AuthorsSearch';
// import AuthorCreate from './components/eqius/crm/AuthorCreate';
// import AuthorDetails from './components/eqius/crm/AuthorDetails';
// 
// import TeachersSearch from './components/eqius/crm/TeachersSearch';
// import TeacherCreate from './components/eqius/crm/TeacherCreate';
// import TeacherDetails from './components/eqius/crm/TeacherDetails';
// 
// import PhasesMilestonesHomepage from './components/eqius/process-governance/phases-and-milestones/PhasesMilestonesHomepage';
// import PhasesCreate from './components/eqius/process-governance/phases-and-milestones/PhasesCreate';
// import PhasesDetails from './components/eqius/process-governance/phases-and-milestones/PhasesDetails';
// import PhasesSearch from './components/eqius/process-governance/phases-and-milestones/PhasesSearch';
// import MilestonesCreate from './components/eqius/process-governance/phases-and-milestones/MilestonesCreate';
// import MilestonesDetails from './components/eqius/process-governance/phases-and-milestones/MilestonesDetails';
// import MilestonesSearch from './components/eqius/process-governance/phases-and-milestones/MilestonesSearch';
// import ProcessControlsHomepage from './components/eqius/process-governance/process-controls/ProcessControlsHomepage';
// import OperationalControlsHomepage from './components/eqius/process-governance/operational-controls/OperationalControlsHomepage';
// import ProblemTickets from './components/eqius/process-governance/operational-controls/ProblemTickets';
// import CreateProblemTicket from './components/eqius/process-governance/operational-controls/CreateProblemTicket';
// import ManageProblemTicket from './components/eqius/process-governance/operational-controls/ManageProblemTicket';
//vlm
import Tasks from './components/vlm/Tasks';
import SearchJournals from './components/vlm/Journals';
import Workflows from './components/vlm/Workflows';
import Circles from './components/vlm/Circles';
import Contacts from './components/vlm/Contacts';
import HomeZones from './components/vlm/HomeZones';
import Vehicles from './components/vlm/Vehicles';
import Cameras from './components/vlm/Cameras';
import Devices from './components/vlm/Devices';
import UserDatabases from './components/vlm/UserDatabases';
import LocationDeviceMetrics from './components/vlm/LocationDeviceMetrics';
import ManageTask from './components/vlm/ManageTask';
import CreateTask from './components/vlm/CreateTask';
import ManageCircle from './components/vlm/ManageCircle';
import CreateCircle from './components/vlm/CreateCircle';
import ManageJournal from './components/vlm/ManageJournal';
import CreateJournal from './components/vlm/CreateJournal';
import JournalView from './components/vlm/JournalView';
import ManageContact from './components/vlm/ManageContact';
import CreateContact from './components/vlm/CreateContact';
import ManageCalendar from './components/vlm/ManageCalendar';
import CreateCalendar from './components/vlm/CreateCalendar';
import CalendarView from './components/vlm/CalendarView';
import ManageWorkflow from './components/vlm/ManageWorkflow';
import CreateWorkflow from './components/vlm/CreateWorkflow';
import ManageArticle from './components/vlm/ManageArticle';
import CreateArticle from './components/vlm/CreateArticle';
import CreateHomeZone from './components/vlm/CreateHomeZone';
import ManageHomeZone from './components/vlm/ManageHomeZone';
import CreateVehicle from './components/vlm/CreateVehicle';
import ManageVehicle from './components/vlm/ManageVehicle';
import CreateCamera from './components/vlm/CreateCamera';
import ManageCamera from './components/vlm/ManageCamera';
import CreateDevice from './components/vlm/CreateDevice';
import ManageDevice from './components/vlm/ManageDevice';
import CreateUserDatabase from './components/vlm/CreateUserDatabase';
import ManageUserDatabase from './components/vlm/ManageUserDatabase';


// styles
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { globalConfig } from './config/config';
//const querystring = require('querystring');
//const platformProperties = require('./config/config');

// const [isLoggedIn, setLoggedIn] = useState(false);
// const [isError, setIsError] = useState(false);
// const [username, setUsername] = useState("");
// const [authToken, setAuthToken] = useState();

// function ValidateUserSession()
// {
// 	const {user, isAuthenticated } = useAuth0();
// 	console.log("authenticated -> " + isAuthenticated);
// 	console.log("user -> " + JSON.stringify(user));
// 	return user;
// }

const theme = createTheme({
  palette: {
    euphoria: {
      light: '#50cb92',
      main: '#25be77',
      dark: '#198553',
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        focusVisible: false,
      },
    },
  },
})

//       {location.pathname === REGISTER_PATIENT ? (
//         <Registration loginWithRedirect={loginWithRedirect}/>
//       ):
// 		((location.pathname === SUBMIT_VITAL_SIGNS) ? (<SubmitVitalSigns loginWithRedirect={loginWithRedirect} />)
// 			: 
// 		((location.pathname === GET_PATIENT_NUMBER) ? (<GetPatientNumber loginWithRedirect={loginWithRedirect} />)
// 			:			
// 			(loginWithRedirect()) 
// 			)
// 		)	
//       }

// const	SecureContent = withAuthenticationRequired(Content);
function BaseApp({ loginWithRedirect }) {
//   const location = useLocation();
	loginWithRedirect;

//     	{    		
//     		(loginWithRedirect())
//     	}

//   return (
//     <>
//     </>
//   )
}

// function logout({ loginWithRedirect}) {
// 	const { logout } = useAuth0();
//     logout({ logoutParams: { returnTo: window.location.origin } });
// }


function App() {
   	const { user, getIdTokenClaims, getAccessTokenSilently, isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

// useEffect(() => {
//   if (user) {
//     const checkClaims = async () => {
//     await getAccessTokenSilently({ cacheMode: 'off' });
//     
//       const claims = await getIdTokenClaims();
//       console.log('FULL CLAIMS2:', JSON.stringify(claims, null, 2));
//     };
//     checkClaims();
//   }
// }, [user]);

//  	console.log("auth vars (loading, authenticated) : " + isLoading + ":" + isAuthenticated);
//  	console.log(`${globalConfig.auth0.clientId}`);
	if (isLoading){		
		return <div>Loading...</div>;
	}
 	if (!isAuthenticated)
 	{
 		console.log('logging in');
 		loginWithRedirect();
 		return <div>Redirecting to login</div>;	
 	}
    return (
    	<>
      <ThemeProvider theme={theme}>
    		<ToastContainer />
            <ErrorBoundary>
            	<Routes>
            	<Route element={<Dashboard />}>
					<Route path="/" element={<Content />} />
					<Route path="/neo" element={<HomepageNeo />}  />
		   	   		<Route path="/dynamo" element={<HomepageDynamo />}  />
		    	  	<Route path="/breeze" element={<HomepageBreeze  />}  />
	    	  		<Route path="/eqius" element={<HomepageEqius  />}  />
	      			<Route path="/waves" element={<HomepageWaves  />}  />
	      			<Route path="/telony" element={<HomepageTelony  />}  />
	      			{/* neo routes 
	      		
	      		<Route path="/neo/find-connectors" element={<FindConnectors />}></Route>
    	  		<Route path="/neo/find-services" element={<FindServices />}></Route>
      			<Route path="/neo/find-transformers" element={<FindNeoTransformers />}></Route>

	      			*/}
	      			<Route path="/gazelle-neo" element={<NeoHomePage />} ></Route>
    	  		<Route path="/neo/connectors" element={<Connectors />}></Route>
      			<Route path="/neo/services" element={<FindServices />}></Route>
	      		<Route path="/neo/transformers" element={<FindNeoTransformers />}></Route>
    	  		<Route path="/neo/create-connector" element={<CreateConnector />}></Route>
      			<Route path="/neo/create-service" element={<CreateService />}></Route>
      			<Route path="/neo/create-transformer" element={<CreateNeoTransformer />}></Route>
      			<Route path="/neo/manage-connector/:id" element={<ManageConnector />}></Route>
      			<Route path="/neo/manage-service/:id" element={<ManageService />}></Route>
      			<Route path="/neo/manage-transformer/:id" element={<ManageNeoTransformer />}></Route>
      			<Route path="/neo/service-scheduler" element={<ServiceScheduler />}></Route>  			
					{/* dynamo routes 
          <Route path = "/dynamo/ManageProject/" element={<ManageProject />}/>
          <Route path="/dynamo/Projects" element={<Projects />} />
					*/}
          <Route path = "/dynamo/ManageRecipes/" element={<ManageRecipes />}/>
          <Route path = "/dynamo/CreateRecipe/" element={<CreateRecipe />}/>
          <Route path = "/dynamo/RecipeDetail/:id" element={<RecipeDetail />}/>
          <Route path = "/dynamo/RecipeSearch/" element={<RecipeSearch />}/>
          <Route path = "/dynamo/RecipeStepSearch/" element={<RecipeStepSearch />}/>
          <Route path = "/dynamo/RecipeStepDetail/:id/:rid" element={<RecipeStepDetail />}/>
          <Route path ="/dynamo/RecipeStepCreate" element = {<RecipeStepCreate />}/>
          <Route path ="/dynamo/Triggers" element = {<Triggers />}/>
          <Route path ="/dynamo/TriggerDetail/:id" element = {<TriggerDetail />}/>
          <Route path ="/dynamo/TriggerCreate" element = {<TriggerCreate />}/>
          <Route path ="/dynamo/LayoutDetails" element = {<LayoutDetails />}/>
          <Route path ="/dynamo/BuildDetails" element = {<BuildDetails />}/>
          <Route path ="/dynamo/DeployDetails" element = {<DeployDetails />}/>
          <Route path ="/dynamo/LayoutDetails/:id" element = {<LayoutDetails />}/>
          <Route path ="/dynamo/BuildDetails/:id" element = {<BuildDetails />}/>
          <Route path ="/dynamo/DeployDetails/:id" element = {<DeployDetails />}/>
          <Route path="/dynamo/ProjectRecipes" element={<ProjectRecipes />} />
          <Route path="/dynamo/transformers" element={<FindDynamoTransformers />} />
          <Route path="/dynamo/manage-transformer/:id" element={<ManageDynamoTransformer />} />
          <Route path="/dynamo/create-transformer" element={<CreateDynamoTransformer />} />
          
          {/*
          	breeze 
          */}
          	<Route path ="/breeze/content-search" exact element={<ContentSearch />} />
			<Route path ="/breeze/content-viewer" exact element={<BreezeContentViewer />} />
			<Route path ="/breeze/content-editor" exact element={<ContentEditor />} />

			<Route path="/breeze/create-content" element={<CreateContent />} />
          	<Route path="/breeze/create-content-type" element={<CreateContentType />} />
          	<Route path="/breeze/Create-Content-annotation" element={<CreateContentAnnotation />} />
          	<Route path="/breeze/Create-Content-application" element={<CreateContentApplication />} />
          	<Route path="/breeze/create-content-association" element={<CreateContentAssociations />} />
          	<Route path="/breeze/create-content-association-type" element={<CreateContentAssociationType />}/>
          	<Route path="/breeze/create-content-category" element={<CreateContentCategories />}/>
          	<Route path="/breeze/create-content-category-type" element={<CreateContentCategoryType />}/>
          	<Route path="/breeze/create-content-descriptor" element={<CreateContentDescriptor />}/>
          	<Route path="/breeze/create-content-descriptor-type" element={<CreateContentDescriptorType />}/>
          	<Route path="/breeze/create-content-facade" element={<CreateContentFacades />}/>
          	<Route path="/breeze/create-content-facade-type" element={<CreateContentFacadesType />}/>
          	<Route path="/breeze/create-content-index-type" element={<CreateContentIndexType />}/>
          	<Route path="/breeze/create-content-index" element={<CreateContentIndex />}/>
          	<Route path="/breeze/create-content-template" element={<CreateContentTemplate />}/>
          	<Route path="/breeze/create-content-template-type" element={<CreateContentTemplateType />}/>

          	<Route path="/breeze/manage-content" element={<ManageContent />}/>
          	<Route path="/breeze/manage-content-associations" element={<ManageContentAssociations />}/>
          	<Route path="/breeze/manage-content-association-types" element={<ManageContentAssociationsTypes />}/>
          	<Route path="/breeze/manage-content-categories" element={<ManageContentCategories />}/>
          	<Route path="/breeze/manage-content-category-types" element={<ManageContentCategoryTypes />}/>
          	<Route path="/breeze/manage-content-descriptors" element={<ManageContentDescriptors />}/>
          	<Route path="/breeze/manage-content-descriptor-types" element={<ManageContentDescriptorTypes />}/>
          	<Route path="/breeze/manage-content-facades" element={<ManagecContentFacades />}/>
          	<Route path="/breeze/manage-content-facade-types" element={<ManagecContentFacadeTypes />}/>
          	<Route path="/breeze/manage-content-types" element={<ManageContentTypes />}/>
          	<Route path="/breeze/manage-content-indices" element={<ManageContentIndices />}/>
          	<Route path="/breeze/manage-content-index-types" element={<ManageContentIndexTypes />}/>
          	<Route path="/breeze/manage-content-templates" element={<ManageContentTemplates />}/>
          	<Route path="/breeze/manage-content-template-types" element={<ManageContentTemplateTypes />}/>
          	<Route path="/breeze/manage-content-transformations" element={<ManageContentTransformations />}/>
          
          	<Route path="/breeze/list-content" element={<ListContent />} />
          	<Route path="/breeze/list-image-catalog" element={<ListImageCatalog />} />
			<Route path="/breeze/list-content-association-types" element={<ListContentAssociationTypes />} />
			<Route path="/breeze/list-content-associations" element={<ListContentAssociations />} />
			<Route path="/breeze/list-content-categories" element={<ListContentCategories />} /> 
			<Route path="/breeze/list-content-category-types" element={<ListContentCategoryTypes />} />
			<Route path="/breeze/list-content-descriptor-types" element={<ListContentDescriptorTypes />} />
			<Route path="/breeze/list-content-descriptors" element={<ListContentDescriptors />} />
			<Route path="/breeze/list-content-facade-types" element={<ListContentFacadeTypes />} />
			<Route path="/breeze/list-content-facades" element={<ListContentFacades />} />
			<Route path="/breeze/list-content-index-types" element={<ListContentIndexTypes />} />
			<Route path="/breeze/list-content-indices" element={<ListContentIndices />} />
			<Route path="/breeze/list-content-template-types" element={<ListContentTemplateTypes />} />
			<Route path="/breeze/list-content-templates" element={<ListContentTemplates />} />
			<Route path="/breeze/list-content-types" element={<ListContentTypes />} />

			{/*
				waves routes 
			*/}
          	<Route path="/waves/versions"  element={<ViewVCSObjects />} />
          	<Route path="/waves/checked-out-files"  element={<ViewVCSCheckedoutObjects />} />
          	<Route path="/waves/version-labels"  element={<ViewVCSLabels />} />
          	<Route path="/waves/create-version"  element={<CreateVCSObject />} />
          	<Route path="/waves/create-revision"  element={<CreateVCSVersion />} />
          	<Route path="/waves/create-label"  element={<CreateVCSLabel />} />
          	<Route path="/waves/checkout"  element={<CreateVCSCheckoutObject />} />

				</Route>
				</Routes>
            </ErrorBoundary>
      </ThemeProvider>
      </>
    )

}

//      	  	{/*
//      	  	<Header authToken={localStorage.getItem('authToken')} accessToken={localStorage.getItem('accessToken')} userId={localStorage.getItem('userId')} currentUserProfile={localStorage.getItem('currentUserProfile')} />			
//       		<LeftNav />
//       		*/}

// 	      	

//                 {isAuthenticated ? (
//                   	<Auth>
// 					</Auth>
//                 ) : (
//                 		<BaseApp loginWithRedirect={loginWithRedirect} />
//                 	)}      

// 
// 	      	<div className="App">
//     	  	<Header authToken={localStorage.getItem('authToken')} accessToken={localStorage.getItem('accessToken')} userId={localStorage.getItem('userId')} currentUserProfile={localStorage.getItem('currentUserProfile')} />			
// 	      	<Route path="/core" exact render={(props) => <Content {...props}  userId={localStorage.getItem('userId')} authToken={localStorage.getItem('authToken')} />} />
// 	      	<Route path="/index.html" exact render={(props) => <Content {...props}  userId={localStorage.getItem('userId')} authToken={localStorage.getItem('authToken')} />}  />
// 	      	<Route path="/user-profile" exact render={(props) => <UserProfile {...props}  userId={localStorage.getItem('userId')} authToken={localStorage.getItem('authToken')} />}  />
//       		</div>

//                  	<BaseApp loginWithRedirect={loginWithRedirect}/>

export default App;

